module.exports = __webpack_public_path__ + "static/media/quota-panel-blank-one.fcbaa37d.png";